import React from "react";
import { FieldRendererProps } from "../types";
import { TextFieldRenderer } from "./TextFieldRenderer";
import { MoneyFieldRenderer } from "./MoneyFieldRenderer";
import { DecimalFieldRenderer } from "./DecimalFieldRenderer";
import { PercentualFieldRenderer } from "./PercentualFieldRenderer";
import { SelectFieldRenderer } from "./SelectFieldRenderer";
import { MaskedFieldRenderer } from "./MaskedFieldRenderer";
import { DateFieldRenderer } from "./DateFieldRenderer";
import { MemoFieldRenderer } from "./MemoFieldRenderer";
import { CheckboxFieldRenderer } from "./CheckboxFieldRenderer";
import { ColorFieldRenderer } from "./ColorFieldRenderer";
import { ToggleFieldRenderer } from "./ToggleFieldRenderer";
import { PasswordFieldRenderer } from "./PasswordFieldRenderer";
import { ImageFieldRenderer } from "./ImageFieldRenderer";
import { FileFieldRenderer } from "./FileFieldRenderer";
import { VideoFieldRenderer } from "./VideoFieldRenderer";
import { SelectGridFieldRenderer } from "./SelectGridFieldRenderer";
import { MultiSelectFieldRenderer } from "./MultiSelectFieldRenderer";
import { SelectWithNumberFieldRenderer } from "./SelectWithNumberFieldRenderer";
import { AlertFieldRenderer } from "./AlertFieldRenderer";
import { CustomFieldRenderer } from "./CustomFieldRenderer";
import { PhotoFieldRenderer } from "./PhotoFieldRenderer";
import { LabelFieldRenderer } from "./LabelFieldRenderer";

export type FieldRendererComponent = React.FC<FieldRendererProps>;

const fieldRenderers: Record<string, FieldRendererComponent> = {
  text: TextFieldRenderer,
  email: TextFieldRenderer,
  number: TextFieldRenderer,
  money: MoneyFieldRenderer,
  decimal: DecimalFieldRenderer,
  percentual: PercentualFieldRenderer,
  select: SelectFieldRenderer,
  date: DateFieldRenderer,
  'datetime-local': DateFieldRenderer,
  memo: MemoFieldRenderer,
  checkbox: CheckboxFieldRenderer,
  color: ColorFieldRenderer,
  toggle: ToggleFieldRenderer,
  senha: PasswordFieldRenderer,
  image: ImageFieldRenderer,
  file: FileFieldRenderer,
  video: VideoFieldRenderer,
  selectgrid: SelectGridFieldRenderer,
  multiselect: MultiSelectFieldRenderer,
  selectwithnumber: SelectWithNumberFieldRenderer,
  aviso: AlertFieldRenderer,
  custom: CustomFieldRenderer,
  photo: PhotoFieldRenderer,
  label: LabelFieldRenderer,
};

export function getFieldRenderer(tipo: string, hasMascara: boolean): FieldRendererComponent {
  if (hasMascara && tipo !== 'select' && tipo !== 'money' && tipo !== 'decimal') {
    return MaskedFieldRenderer;
  }
  return fieldRenderers[tipo] || TextFieldRenderer;
}

export { fieldRenderers };
